import { create } from 'zustand';

interface AppTypeState {
  type: 'UNIVERSAL' | 'FOCUS' | undefined;
  tenant: string | undefined;
  setAppType: ({ type, tenant }: { type: 'UNIVERSAL' | 'FOCUS'; tenant?: string }) => void;
}

// The host bootstrap (host/src/main.tsx) resolves the app type before render and
// writes it here; `useAppType` reads it. App type is boot-time config resolved
// once, so a store fits better than a never-invalidated react-query entity.
export const useAppTypeStore = create<AppTypeState>((set) => ({
  type: undefined,
  tenant: undefined,
  setAppType: ({ type, tenant }) => set({ type, tenant }),
}));
